import Color from "color";

import { colors } from "@apps/viewer/src/ts/config";

/**
 * Collection of shared configurations within the header.
 */
export const config = {
    /**
     * Specifies the background color to apply to the header and footer of the
     * application.
     */
    backgroundColor: Color(colors.white)
        .alpha(0.96)
        .toString(),

    /**
     * Specifies the color to apply to the dropshadow that's cast by the header
     * and footer.
     */
    dropShadowColor: Color(colors.black)
        .alpha(0.1)
        .toString(),

    /**
     * Specifies the color code used to render tools in the header, when they're
     * not already activated somehow.
     */
    toolColor: "#8f8f8f",

    /**
     * Generate the color to apply behind items on hover, by fading the default
     * black color out to the desired opacity.
     */
    hoverBackgroundColor: Color(colors.black)
        .alpha(0.05)
        .toString(),
};
